angular.module('cfn').directive('cfnBookingMachine', cfnBookingMachine);

cfnBookingMachine.$inject = [
  'bookingRules',
  'bookingService',
  '$timeout',
  'search.service',
  'companyFinanceService',
  'userSettingsService'
];
function cfnBookingMachine(
  bookingRules,
  bookingService,
  $timeout,
  searchService,
  companyFinanceService,
  userSettingsService
) {
  return {
    restrict: 'E',
    templateUrl: require('./machineTable.html'),
    controller: [
      '$scope',
      function($scope) {
        $scope.isEngland = userSettingsService.getIsoCountryEnum() === 'GBR';
        $scope.currencySign = companyFinanceService.getCurrencySign();

        var objectType = $scope.ele.name,
          type = 'resource',
          list = objectType + 'List';

        // Load data from common booking state object into local format
        bookingRules.elements.machine.onLoad = function(result) {
          // result.resources[resourceType=="Person"] -> $scope.details.personList
          $scope.details.machineList = result.resources.filter(function(
            resource
          ) {
            return resource.resourceType === 'Machine';
          });
          if (searchIndex) {
            searchIndex.clearExcludedItems();
          }
          excludeAllAddedFields();
        };

        // Transform details-data (fieldList, seedList, ...) to BE-Data (assets, products,...)
        bookingRules.elements.machine.onSave = function(result) {
          if (!angular.isArray(result.resources)) result.resources = [];
          if ($scope.details.machineList)
            $scope.details.machineList.forEach(function(machine) {
              machine.resourceType = 'Machine';
              result.resources.push(machine);
            });
        };

        bookingRules.elements.machine.onInsert = function(recourceDTO) {
          var newItem = recourceDTO;

          // Area is sum of all fields per default
          newItem.workedArea = $scope.details.fieldList_farmedArea_sum;
          if (newItem.unit == 'AREAL_HA') {
            newItem.amount = newItem.workedArea;
          } else {
            newItem.amount = 0;
          }

          // set id in item for easy unique-check.
          newItem.feid = recourceDTO.resource.id;

          bookingService.addToList($scope, newItem, 'machineList');
          excludeAllAddedFields();
        };

        function excludeAllAddedFields() {
          _.each($scope.details.machineList, function(item) {
            searchIndex.excludeFromIndex(item.resource.id);
          });
        }

        $scope.remove = function(item) {
          searchIndex.undoExcludeFromIndex(item.resource.id);
          $scope.controller.removeFromList(objectType, type, list, item);
        };

        $scope.checkUnit = function(item) {
          $timeout(function() {
            if (item.unit == 'AREAL_HA') {
              item.amount = item.workedArea;
            }
          });
        };

        //search
        var searchIndex = searchService('machine', {
          initOnFirstSearch: true
        }).buildIndex({
          fullText: function(item) {
            return [item.number, item.name, enums.MachineFamilyEnum[item.type]];
          },
          handleResults: function(data) {
            data.map(function(elem) {
              elem._objectType = objectType; //this is required later on but legacy code...
            });
            return data;
          }
        });

        $scope.search = searchIndex.fullTextSearch;
        $scope.searchSelected = function(selectedItem) {
          $scope.addToList(objectType, type, list, null)(selectedItem);
        };
      }
    ]
  };
}
